import * as React from 'react';
import { StackLayout, TextAction, Box } from '@leagueplatform/genesis-core';
import { Tag } from '@web-config-app/core-react-ui';

type ChangeAssetActionsProps = {
  onChange: () => void;
  showLocaleBadge: boolean;
  locale: string;
  label: React.ReactNode;
};

export const ChangeAssetActions: React.FC<ChangeAssetActionsProps> = ({
  onChange,
  showLocaleBadge,
  locale,
  label,
}) => (
  <StackLayout
    orientation="horizontal"
    spacing="$half"
    verticalAlignment="center"
    horizontalAlignment="end"
    css={{ whiteSpace: 'nowrap', flexShrink: 0 }}
  >
    <TextAction
      as="button"
      css={{
        textDecoration: 'underline',
        fontWeight: '$semibold',
        whiteSpace: 'nowrap',
      }}
      onClick={onChange}
      size="medium"
    >
      {label}
    </TextAction>
    {showLocaleBadge && (
      <Box css={{ marginInlineStart: '$one' }}>
        <Tag label={locale} />
      </Box>
    )}
  </StackLayout>
);
